// Import images for food
import Chicken from "../pictures/nutrition/food/chickenBreast.jpg";
import Avocado from "../pictures/nutrition/food/avocado.jpg";
import Fish from "../pictures/nutrition/food/fish.jpg";
import Nuts from "../pictures/nutrition/food/nuts.jpg";
import Rice from "../pictures/nutrition/food/rice.jpg";
import SweetPotato from "../pictures/nutrition/food/sweetPotato.jpg";
import WholeBread from "../pictures/nutrition/food/wholeBread.jpg";
import Egg from "../pictures/nutrition/food/egg.jpg";
import Salmon from "../pictures/nutrition/food/salmon.jpg";
import Tuna from "../pictures/nutrition/food/tuna.jpg";
import CottageCheese from "../pictures/nutrition/food/cottageCheese.jpg";
import GreekYogurt from "../pictures/nutrition/food/greekYogurt.jpg";
import Lentils from "../pictures/nutrition/food/lentils.jpg";
import PeanutButter from "../pictures/nutrition/food/peanutButter.jpg";
import Quinoa from "../pictures/nutrition/food/quinoa.jpg";
import Oats from "../pictures/nutrition/food/oats.jpg";
import Blueberries from "../pictures/nutrition/food/blueberries.jpg";
import Banana from "../pictures/nutrition/food/banana.jpg";
import OliveOil from "../pictures/nutrition/food/oliveOil.jpg";
import Flaxseeds from "../pictures/nutrition/food/flaxseeds.jpg";
import Walnuts from "../pictures/nutrition/food/walnuts.jpg";
import Spinach from "../pictures/nutrition/food/spinach.jpg";
import Broccoli from "../pictures/nutrition/food/broccoli.jpg";
import Carrot from "../pictures/nutrition/food/carrot.jpg";
import Apple from "../pictures/nutrition/food/apple.jpg";
import Potato from "../pictures/nutrition/food/potato.jpg";
import Cheese from "../pictures/nutrition/food/cheese.jpg";
import Butter from "../pictures/nutrition/food/butter.jpg";
import Sardines from "../pictures/nutrition/food/sardines.jpg";
import Mackerel from "../pictures/nutrition/food/mackerel.jpg";
import Shrimp from "../pictures/nutrition/food/shrimp.jpg";
import Crab from "../pictures/nutrition/food/crab.jpg";
import Tofu from "../pictures/nutrition/food/tofu.jpg";
import Tempeh from "../pictures/nutrition/food/tempeh.jpg";
import Chickpeas from "../pictures/nutrition/food/chickpeas.jpg";
import KidneyBeans from "../pictures/nutrition/food/kidneyBeans.jpg";
//import BlackBeans from "../pictures/nutrition/food/blackBeans.jpg";
import Edamame from "../pictures/nutrition/food/edamame.jpg";
import GreenBeans from "../pictures/nutrition/food/greenBeans.jpg";
import Mushroom from "../pictures/nutrition/food/mushroom.jpg";

const foodData = [
  {
    id: 1,
    name: "Poulet",
    image: Chicken,
    description: "Riche en protéines maigres et pauvre en graisses.",
    macronutrient: ["Protéines"],
  },
  {
    id: 2,
    name: "Poisson",
    image: Fish,
    description: "Excellente source de protéines et d'oméga-3.",
    macronutrient: ["Protéines", "Lipides"],
  },
  {
    id: 3,
    name: "Avocat",
    image: Avocado,
    description: "Source de graisses mono-insaturées bénéfiques pour le cœur.",
    macronutrient: ["Lipides"],
  },
  {
    id: 4,
    name: "Riz",
    image: Rice,
    description: "Une source d'énergie rapide et sans gluten.",
    macronutrient: ["Glucides"],
    carbType: "Complex",
  },
  {
    id: 5,
    name: "Noix",
    image: Nuts,
    description: "Riches en graisses saines et en protéines.",
    macronutrient: ["Lipides", "Protéines"],
  },
  {
    id: 6,
    name: "Oeufs",
    image: Egg,
    description: "Riches en protéines complètes et en nutriments essentiels.",
    macronutrient: ["Protéines", "Lipides"],
  },
  {
    id: 7,
    name: "Patates douces",
    image: SweetPotato,
    description: "Riches en glucides complexes et en fibres.",
    macronutrient: ["Glucides"],
    carbType: "Complex",
  },
  {
    id: 8,
    name: "Pain complet",
    image: WholeBread,
    description: "Source de fibres et de glucides complexes.",
    macronutrient: ["Glucides"],
  },
  {
    id: 9,
    name: "Saumon",
    image: Salmon,
    description: "Riche en protéines et en acides gras oméga-3.",
    macronutrient: ["Protéines", "Lipides"],
  },
  {
    id: 10,
    name: "Thon",
    image: Tuna,
    description: "Excellente source de protéines faibles en graisses.",
    macronutrient: ["Protéines"],
  },
  {
    id: 11,
    name: "Fromage blanc",
    image: CottageCheese,
    description: "Riche en protéines et faible en matières grasses.",
    macronutrient: ["Protéines"],
  },
  {
    id: 12,
    name: "Yaourt grec",
    image: GreekYogurt,
    description: "Riche en protéines et en probiotiques.",
    macronutrient: ["Protéines", "Lipides"],
  },
  {
    id: 13,
    name: "Lentilles",
    image: Lentils,
    description: "Source de protéines végétales et de fibres.",
    macronutrient: ["Protéines", "Glucides"],
  },
  {
    id: 14,
    name: "Beurre de cacahuète",
    image: PeanutButter,
    description: "Riche en graisses saines et en protéines.",
    macronutrient: ["Lipides", "Protéines"],
  },
  {
    id: 15,
    name: "Quinoa",
    image: Quinoa,
    description: "Une protéine complète et source de glucides complexes.",
    macronutrient: ["Protéines", "Glucides"],
  },
  {
    id: 16,
    name: "Flocons d'avoine",
    image: Oats,
    description: "Excellente source de glucides lents et de fibres.",
    macronutrient: ["Glucides"],
  },
  {
    id: 17,
    name: "Myrtilles",
    image: Blueberries,
    description: "Riche en antioxydants et en vitamine C.",
    macronutrient: ["Glucides"],
    carbType: "Simple",
  },
  {
    id: 18,
    name: "Banane",
    image: Banana,
    description: "Source rapide d'énergie et riche en potassium.",
    macronutrient: ["Glucides"],
    carbType: "Simple",
  },
  {
    id: 19,
    name: "Huile d'olive",
    image: OliveOil,
    description: "Source de graisses mono-insaturées et antioxydants.",
    macronutrient: ["Lipides"],
  },
  {
    id: 20,
    name: "Graines de lin",
    image: Flaxseeds,
    description: "Riche en oméga-3 et en fibres.",
    macronutrient: ["Lipides", "Glucides"],
  },
  {
    id: 21,
    name: "Épinards",
    image: Spinach,
    description: "Faible en calories et riche en fer.",
    macronutrient: ["Glucides"],
  },
  {
    id: 22,
    name: "Brocolis",
    image: Broccoli,
    description: "Riche en vitamine C et en fibres.",
    macronutrient: ["Glucides"],
  },
  {
    id: 23,
    name: "Carottes",
    image: Carrot,
    description: "Source de vitamine A et de fibres.",
    macronutrient: ["Glucides"],
  },
  {
    id: 24,
    name: "Pommes",
    image: Apple,
    description: "Source naturelle de fibres et de sucres.",
    macronutrient: ["Glucides"],
  },
  {
    id: 25,
    name: "Pommes de terre",
    image: Potato,
    description: "Riches en glucides et source d'énergie rapide.",
    macronutrient: ["Glucides"],
  },
  {
    id: 26,
    name: "Beurre",
    image: Butter,
    description: "Riche en graisses saturées.",
    macronutrient: ["Lipides"],
  },
  {
    id: 27,
    name: "Sardines",
    image: Sardines,
    description: "Riche en protéines et en oméga-3.",
    macronutrient: ["Protéines", "Lipides"],
  },
  {
    id: 28,
    name: "Maquereaux",
    image: Mackerel,
    description: "Excellente source de protéines et de graisses saines.",
    macronutrient: ["Protéines", "Lipides"],
  },
  {
    id: 29,
    name: "Crevettes",
    image: Shrimp,
    description: "Riche en protéines et faible en calories.",
    macronutrient: ["Protéines"],
  },
  {
    id: 30,
    name: "Crabe",
    image: Crab,
    description: "Faible en calories et riche en protéines.",
    macronutrient: ["Protéines"],
  },
  {
    id: 31,
    name: "Tofu",
    image: Tofu,
    description: "Source végétale de protéines.",
    macronutrient: ["Protéines"],
  },
  {
    id: 32,
    name: "Tempeh",
    image: Tempeh,
    description: "Riche en protéines et en probiotiques.",
    macronutrient: ["Protéines"],
  },
  {
    id: 33,
    name: "Pois chiches",
    image: Chickpeas,
    description: "Riche en fibres, glucides, et protéines.",
    macronutrient: ["Protéines", "Glucides"],
  },
  {
    id: 34,
    name: "Haricots rouges",
    image: KidneyBeans,
    description: "Bonne source de protéines et de glucides.",
    macronutrient: ["Protéines", "Glucides"],
  },
  //   {
  //     id: 35,
  //     name: "Haricots noirs",
  //     image: BlackBeans,
  //     description: "Source de protéines végétales et de glucides complexes.",
  //     macronutrient: ["Protéines", "Glucides"],
  //   },
  {
    id: 36,
    name: "Edamame",
    image: Edamame,
    description: "Source de protéines végétales et de fibres.",
    macronutrient: ["Protéines", "Glucides"],
  },
  {
    id: 37,
    name: "Haricots verts",
    image: GreenBeans,
    description: "Faibles en calories et riches en fibres.",
    macronutrient: ["Glucides"],
  },
  {
    id: 38,
    name: "Champignons",
    image: Mushroom,
    description: "Riche en antioxydants et faible en calories.",
    macronutrient: ["Glucides"],
  },
];

export default foodData;
